import { render } from "./TestResultGuideForPublwizProduct.vue?vue&type=template&id=28eea5d9&scoped=true"
import script from "./TestResultGuideForPublwizProduct.vue?vue&type=script&lang=js"
export * from "./TestResultGuideForPublwizProduct.vue?vue&type=script&lang=js"

import "./TestResultGuideForPublwizProduct.vue?vue&type=style&index=0&id=28eea5d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28eea5d9"]])

export default __exports__